import {
  Divider,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
  IconButton,
  AppBar,
  Toolbar,
  CircularProgress,
  TextField,
  AccordionSummary,
  AccordionDetails,
  Accordion,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PlaceIcon from '@material-ui/icons/Place';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ReportIcon from '@material-ui/icons/Report';
import ReportOffIcon from '@material-ui/icons/ReportOff';
import EditIcon from '@material-ui/icons/Edit';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext, useRef } from 'react';
import classnames from 'classnames';
import FormDefinition from './FormDefinition';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import { OrderReviewContext, updateFormHeaderImageLocations } from './OrderReviewContext';
import TimeAgo from './TimeAgo';
import ImageEditor from '../ImageEditor';
import { format } from 'date-fns';

// SERVICES
import { updateFormDefinitionImage } from '../../services';
import { useDeepEffect } from '../../helpers';
import { set } from 'lodash';
import { useInsertionEffect } from 'react';

const propTypes = {
  // classes: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired,
  saveAnswers: PropTypes.func.isRequired,
  removeAnswers: PropTypes.func.isRequired,
  formHeader: PropTypes.object.isRequired,
};

function DialogListItem({
  //
  pictureFormDefinition,
  selectedLocationFormDefinitions,
  setSelectedLocationFormDefinitions,
  state,
  classes,
  condensed = false,
  onCheck,
  locationsInModal,
  setLocationsInModal,
}) {
  // Is this location currently selected for the image?
  const getIsChecked = () => {
    return selectedLocationFormDefinitions.find(
      fd =>
        fd.formDefinitionId === pictureFormDefinition.formDefinitionId &&
        fd.orderFormHeaderId === pictureFormDefinition.orderFormHeaderId,
    )
      ? true
      : false;
  };
  const [isChecked, setIsChecked] = useState(getIsChecked);

  // Update isChecked is the selected locations change
  useEffect(() => {
    if (selectedLocationFormDefinitions) {
      setIsChecked(getIsChecked);
    }
  }, [selectedLocationFormDefinitions]);

  // If location is already selected, unselect it and vice versa.
  const handleLocationToggle = () => {
    let newSelectedLocationFormDefinitions = locationsInModal;

    if (isChecked) {
      newSelectedLocationFormDefinitions = locationsInModal.filter(
        sifd =>
          !(
            sifd.formDefinitionId == pictureFormDefinition.formDefinitionId &&
            sifd.orderFormHeaderId == pictureFormDefinition.orderFormHeaderId
          ),
      );
    } else {
      // newSelectedLocationFormDefinitions.push(pictureFormDefinition);
      newSelectedLocationFormDefinitions = newSelectedLocationFormDefinitions.concat(pictureFormDefinition);
    }

    setLocationsInModal(newSelectedLocationFormDefinitions);
    setIsChecked(!isChecked);

    !!onCheck && onCheck();
  };

  const dialogListItemFormHeader = state.formHeaders.find(
    fh => fh.orderFormHeaderId === pictureFormDefinition.orderFormHeaderId,
  );

  return (
    <ListItem
      button
      onClick={handleLocationToggle}
      style={{
        ...(condensed && {
          padding: 0,
          margin: 0,
          // display: 'flex',
          // flexDirection: 'row',
          // alignItems: 'flex-start',
        }),
      }}
    >
      <ListItemIcon
        classes={{
          root: classes.listItemIconCheck,
          ...(condensed && {
            padding: 0,
            margin: 0,
          }),
        }}
      >
        <Checkbox checked={isChecked} />
      </ListItemIcon>
      <ListItemText
        style={{
          ...(condensed &&
          {
            // padding: 0,
            // margin: 0,
          }),
        }}
        primary={pictureFormDefinition.questionValue.replace('Take Photo: ', '')}
        primaryTypographyProps={{
          style: {
            fontSize: '1rem',
            fontWeight: '700',
            margin: '12px 0 0 0',
            color: '#000',

            ...(condensed && {
              padding: 0,
              margin: 0,
            }),
          },
        }}
        secondary={
          dialogListItemFormHeader.duplicateOrder
            ? `${dialogListItemFormHeader.name} #${dialogListItemFormHeader.duplicateOrder}`
            : `${dialogListItemFormHeader.name}`
        }
        secondaryTypographyProps={{
          style: {
            fontSize: '0.75rem',
          },
        }}
      />
    </ListItem>
  );
}

function ImageCard({ classes, image, saveAnswers, removeAnswers, formHeader }) {
  const imageSrc = image.imageUri.replace('fieldrepimage', 'fieldrepimagelarge').replace('/raw/', '/large/');
  const DEBUG = false; // imageSrc === 'https://jmistorage.blob.core.windows.net/staging-inspection-images/large/220502630/ad1c8548-58de-4496-981b-f7185d024132_1679533695709.jpg';

  const maxImageHeight = window.screen.height * 0.5;

  const { state, dispatch } = useContext(OrderReviewContext);
  const [imageLabel, setImageLabel] = useState(image.label);
  const [imageDescription, setImageDescription] = useState(image.description);
  const [questionSearchText, setQuestionSearchText] = useState('');
  const [isEditLocationsDialogOpen, setIsEditLocationsDialogOpen] = useState(false);
  const [shouldSaveLocations, setShouldSaveLocations] = useState(false);
  const [imageSize, setImageSize] = useState();
  const [imageProps, setImageProps] = useState({ style: {} });
  const [imageContainerProps, setImageContainerProps] = useState({ style: {} });
  const [selectedLocationsInModal, setSelectedLocationsInModal] = useState(null);

  const isLandscape = [0, 180].includes(image.rotateDegree);

  const imgWrapperRef = useRef(null);
  const divImgWrapper = useRef(null);

  const handleEditLocationDialogOpen = () => {
    setIsEditLocationsDialogOpen(true);
  };

  const handleEditLocationDialogClose = () => {
    setIsEditLocationsDialogOpen(false);

    // find and remove the selected locations that are not saved
    // find saved locations using the selected locations
    // if a location hasn't been saved yet then it shouldn't be in locationFormDefinitions
    const removableLocations = locationFormDefinitions.filter(lfd =>
      selectedLocationFormDefinitions.some(
        slfd => slfd.orderFormHeaderId === lfd.orderFormHeaderId && selectedLocationFormDefinitions.includes(lfd),
      ),
    );

    setSelectedLocationsInModal(removableLocations);
  };

  // LocationFormDefinitions holds state for the form definitions where answer type = 'Picture'.
  // These are the form definitions that images can be added or removed from
  const [locationFormDefinitions, setLocationFormDefinitions] = useState(null);
  useEffect(() => {
    if (state.formHeaders) {
      setLocationFormDefinitions(getLocationFormDefinitions);
    }
  }, [state.formHeaders]);

  const getLocationFormDefinitions = () => {
    return state.formHeaders
      .filter(fh => fh.formDefinitions)
      .map(fh => fh.formDefinitions.filter(fd => fd.answerType === 'Picture'))
      .flat();
  };

  // SelectedLocationFormDefinitions holds state for the selected locations for the image.
  // This state is updated when different location(s) are selected and updated/removed when the current image changes.
  const [selectedLocationFormDefinitions, setSelectedLocationFormDefinitions] = useState(null);

  useEffect(() => {
    if (locationFormDefinitions) {
      setSelectedLocationFormDefinitions(getSelectedLocationFormDefinitions);
      setSelectedLocationsInModal(getSelectedLocationFormDefinitions);
    }
  }, [locationFormDefinitions]);

  useEffect(() => {
    if (shouldSaveLocations) {
      setShouldSaveLocations(false);
      saveEditLocationChanges();
    }
  }, [shouldSaveLocations]);

  const getSelectedLocationFormDefinitions = () => {
    return locationFormDefinitions.filter(fd =>
      fd.answers.find(a => a.images.find(i => i.formQaImageId === image.formQaImageId)),
    );
  };

  // Handles the save of the new selected locations for an images
  const saveEditLocationChanges = () => {
    const { formHeaders, answers } = updateFormHeaderImageLocations(state, {
      image: image,
      locationFormDefinitions: [], //locationFormDefinitions,
      selectedLocationFormDefinitions: selectedLocationsInModal,
    });
    dispatch({
      type: 'OVERRIDE_FORM_HEADERS',
      formHeaders,
    });
    saveAnswers(answers, image);
    setSelectedLocationFormDefinitions(selectedLocationsInModal);
  };

  const updateActiveFormHeaderImage = async image => {
    dispatch({
      type: 'IS_AUTO_SAVING',
      value: true,
    });
    dispatch({
      type: 'UPDATE_IMAGE',
      image: image,
    });
    try {
      const result = await updateFormDefinitionImage(image);
      dispatch({
        type: 'IS_AUTO_SAVING',
        value: false,
      });
    } catch (err) {
      dispatch({
        type: 'IS_AUTO_SAVING',
        value: false,
      });
    }
  };

  const toggleImageVisibilityOnReport = () => {
    const updatedImage = Object.assign({}, image);
    updatedImage.hideImage = !updatedImage.hideImage;
    updateActiveFormHeaderImage(updatedImage);
  };

  const toggleImageFraudIndicator = () => {
    const updatedImage = Object.assign({}, image);
    updatedImage.fraudulent = !updatedImage.fraudulent;
    updateActiveFormHeaderImage(updatedImage);
  };


  const rotateImage = () => {
    const imageRotationDegrees = [0, 90, 180, 270];
    const updatedImage = Object.assign({}, image);
    let currentRotateDegreeIdx = imageRotationDegrees.findIndex(deg => deg === updatedImage.rotateDegree);
    currentRotateDegreeIdx = currentRotateDegreeIdx === -1 ? 0 : currentRotateDegreeIdx;
    const newRotateDegreeIdx =
      currentRotateDegreeIdx + 1 === imageRotationDegrees.length ? 0 : currentRotateDegreeIdx + 1;
    updatedImage.rotateDegree = imageRotationDegrees[newRotateDegreeIdx];
    updateActiveFormHeaderImage(updatedImage);
    handleUpdateImageProps(updatedImage.rotateDegree);
  };

  // resize image based on rotation angle
  const resizeImage = rotateDegrees => {
    // check the angle of rotation
    if (rotateDegrees === 1 || rotateDegrees === 3) {
      imgWrapperRef.current.style.transform = 'scale(1)';
      setImageSize({});
    } else {
      divImgWrapper.current.style.transformOrigin = 'center';
      imgWrapperRef.current.style.transform = 'scaleY(0.5)';
      imgWrapperRef.current.style.transform = 'scaleX(1)';
      imgWrapperRef.current.style.width = '100%';
      imgWrapperRef.current.style.height = '100%';
      setImageSize({
        height: imgWrapperRef.current.offsetWidth,
        width: imgWrapperRef.current.offsetWidth,
      });
    }
  };

  const getFormDefinitions = () => {
    const fds = state.formHeaders
      .filter(fh => fh.formDefinitions)
      .map(fh =>
        fh.formDefinitions.filter(
          fd =>
            fd.answers.length > 0 &&
            fd.answers.some(
              a => a.images.length > 0 && a.images.some(i => i && i.formQaImageId === image.formQaImageId),
            ),
        ),
      )
      .flat();
    return fds;
  };
  const [formDefinitions, setFormDefinitions] = useState(getFormDefinitions());
  useEffect(() => {
    setFormDefinitions(getFormDefinitions());
  }, [state.formHeaders]);

  const getIssueFormDefinitions = () => {
    const liabilityConditionFormDefinitions = state.formHeaders
      .filter(fh => fh.formDefinitions)
      .map(fh =>
        fh.formDefinitions.filter(
          fd =>
            fd.questionCategoryName === 'Liability' ||
            fd.questionCategoryName === 'Condition' ||
            fd.questionCategoryName === 'Risk Characteristic' ||
            formDefinitions.some(fds => fds.formDefinitionId === fd.formDefinitionId && fd.answerType !== 'Picture'), // This is a catch all to make sure any formDefinition that is attached to an image is shown even if it is not a liability or condition.
        ),
      )
      .flat();
    return liabilityConditionFormDefinitions;
  };

  const [issueFormDefinitions, setIssueFormDefinitions] = useState(getIssueFormDefinitions());

  useEffect(() => {
    setIssueFormDefinitions(getIssueFormDefinitions());
  }, [state.formHeaders]);

  useEffect(() => {
    if (!state.isAutoSaving && isEditLocationsDialogOpen) {
      handleEditLocationDialogClose();
    }
  }, [state.isAutoSaving]);

  useEffect(() => {
    if (divImgWrapper.current) {
      handleUpdateImageProps(image.rotateDegree);
    }
  }, [divImgWrapper.current]);

  const [isEditIssueDialogOpen, setIsEditIssueDialogOpen] = useState(false);

  const handleEditIssueDialogOpen = () => {
    setQuestionSearchText('');
    setIsEditIssueDialogOpen(true);
  };

  const handleEditIssueDialogClose = () => {
    setIsEditIssueDialogOpen(false);
  };

  const handlePropertyChange = async (propertyName, event) => {
    const value = event.target.value;
    switch (propertyName) {
      case 'Label':
        setImageLabel(value);
        break;
      case 'Description':
        setImageDescription(value);
        break;
      default:
        break;
    }
  };

  const handlePropertySave = async () => {
    const updatedImage = Object.assign({}, image);
    updatedImage.label = imageLabel;
    updatedImage.description = imageDescription;
    updateActiveFormHeaderImage(updatedImage);
  };

  const isQaOnlyAnswer = formDefinition => {
    return formDefinition.dataSources.some(ds => ds === 'QA') ? <span style={{ color: 'red' }}>*</span> : '';
  };

  const getImageAnswerCount = formDefinition => {
    return (
      formDefinition.answers.filter(a => a.images.some(i => i && i.formQaImageId === image.formQaImageId)).length > 0 &&
      ` (${formDefinition.answers.filter(a => a.images.some(i => i && i.formQaImageId === image.formQaImageId)).length
      })`
    );
  };

  const photoSpecificFormDefs = issueFormDefinitions.filter(
    fd =>
      fd.answerType === 'Multi Select' &&
      fd.answerType !== 'Picture' &&
      (fd.orderFormHeaderId === formHeader.orderFormHeaderId ||
        (selectedLocationFormDefinitions &&
          selectedLocationFormDefinitions.find(s => s.orderFormHeaderId === fd.orderFormHeaderId))) &&
      (!questionSearchText || fd.questionValue?.toLowerCase()?.includes(questionSearchText.toLowerCase())),
  );
  const generalFormDefs = issueFormDefinitions.filter(
    fd =>
      fd.answerType !== 'Multi Select' &&
      fd.answerType !== 'Picture' &&
      (fd.orderFormHeaderId === formHeader.orderFormHeaderId ||
        (selectedLocationFormDefinitions &&
          selectedLocationFormDefinitions.find(s => s.orderFormHeaderId === fd.orderFormHeaderId))) &&
      (!questionSearchText || fd.questionValue?.toLowerCase()?.includes(questionSearchText.toLowerCase())),
  );

  const locationFormDefinitionsByFormHeader = Object.entries(
    (locationFormDefinitions || []).reduce((acc, fd) => {
      if (!acc[fd.formHeaderId]) {
        acc[fd.formHeaderId] = [];
      }

      acc[fd.formHeaderId].push(fd);

      return acc;
    }, {}),
  );

  const handleUpdateImageProps = rotateDegree => {
    const { clientWidth, clientHeight } = divImgWrapper.current;

    let updatedStageProps = { style: {} };
    let updatedImageProps = { style: {} };

    const fakeImage = new window.Image();
    fakeImage.src = imageSrc;

    fakeImage.onload = () => {
      const aspectRatio = fakeImage.naturalWidth / fakeImage.naturalHeight;

      const height = Math.min(clientHeight, maxImageHeight);
      const width = clientWidth;

      const initialImgWidth = Math.min(width, clientWidth);

      const fullImgHeight = initialImgWidth / aspectRatio;
      const imgHeight = Math.min(fullImgHeight, maxImageHeight);
      const imgWidth = imgHeight * aspectRatio;

      const widthScale = imgWidth / width;
      const heightScale = imgHeight / fullImgHeight;

      updatedStageProps.style.height = height;
      updatedStageProps.style.width = width;

      updatedImageProps.style.height = imgHeight;
      updatedImageProps.style.width = imgWidth;
      updatedImageProps.style.transform = `rotate(${rotateDegree}deg)`;

      const scale = Math.min(
        1 / (updatedImageProps.style.width / height),
        1 / (updatedImageProps.style.height / width),
      );

      switch (rotateDegree) {
        case 0:
          updatedImageProps.style.boxShadow = '2px 10px 15px rgb(0 0 0 / 25%)';
          //
          break;
        case 90:
          updatedImageProps.style.boxShadow = '10px -2px 15px rgb(0 0 0 / 25%)';

          updatedImageProps.style.height = updatedImageProps.style.height * scale;
          updatedImageProps.style.width = updatedImageProps.style.width * scale;

          updatedImageProps.style.marginTop = (updatedImageProps.style.width - updatedImageProps.style.height) / 2;

          if (width < updatedImageProps.style.width) {
            updatedImageProps.style.marginLeft = (width - updatedImageProps.style.width) / 2;
          }
          break;
        case 180:
          updatedImageProps.style.boxShadow = '-2px -10px 15px rgb(0 0 0 / 25%)';
          //
          break;
        case 270:
          updatedImageProps.style.boxShadow = '-10px 2px 15px rgb(0 0 0 / 25%)';

          updatedImageProps.style.height = updatedImageProps.style.height * scale;
          updatedImageProps.style.width = updatedImageProps.style.width * scale;

          updatedImageProps.style.marginTop = (updatedImageProps.style.width - updatedImageProps.style.height) / 2;

          if (width < updatedImageProps.style.width) {
            updatedImageProps.style.marginLeft = (width - updatedImageProps.style.width) / 2;
          }

          break;
      }

      DEBUG &&
        console.log({
          updatedStageProps,
          updatedImageProps,
          initialImgWidth,
          fakeImage,
          aspectRatio,
          width,
          height,
          imgWidth,
          imgHeight,
          fullImgHeight,
          maxImageHeight,
          widthScale,
          heightScale,
          rotateDegree,
        });

      setImageContainerProps(updatedStageProps);
      setImageProps(updatedImageProps);
    };
  };

  const imageLocation = (image) => {
    if (formHeader.name == "Aerial Images") {
      return (
        <>
          <img
            src='https://jmistorage.blob.core.windows.net/testing/map-pinIcon.svg'
            style={{ height: '30px', width: '30px' }}
          />
        </>
      )
    } else {
      if (image.homeOwnerRemote == true) {
        return (
          <>
            <img
              src="https://jmistorage.blob.core.windows.net/testing/homeIcon.svg"
              style={{ height: '30px', width: '30px' }}
            />
          </>
        )
      } else {
        return (
          <>
            <img
              src="https://jmistorage.blob.core.windows.net/testing/userIcon.svg"
              style={{ height: '30px', width: '30px' }}
            />
          </>
        )

      }
    }

  }

  const geoLocationIcon = (image) => {
    if (image.latitude !=  undefined && image.longitude != undefined) {
      return (
        <>
          <img
            src='https://jmistorage.blob.core.windows.net/testing/flat_location_logo.svg'
            style={{ height: '30px', width: '30px' }}
          />
        </>
      )
    } 

  }

  const geoFenceIcon = (image) => {
    if (image.inGeoFence == true) {
      return (
        <>
          <img
            src='https://jmistorage.blob.core.windows.net/testing/geofence-icon.svg'
            style={{ height: '30px', width: '30px' }}
          />
        </>
      )
    } 

  }

  const filterFormDefs = (formDef, image) => {



    const filteredFormHeaders = formDef.map(fd => ({
      ...fd,
      answers: fd.answers.filter(a => a.images.find(i => i.formQaImageId === image.formQaImageId))
    })).filter(fd => fd.answers.length > 0);


    return (
      filteredFormHeaders.map(fd => (
        <FormDefinition
          key={fd.formDefinitionId + '-' + fd.orderFormHeaderId}
          saveAnswers={saveAnswers}
          removeAnswers={removeAnswers}
          formDefinition={fd}
          showMinimalPhotoTaggedButton
          // isReadOnly={true}
          imageToEdit={image}
          duplicateQuestion={formDefinitions.some(
            fds => fds.questionId === fd.questionId && fds.formDefinitionId !== fd.formDefinitionId,
          )
          }
          imageTag={true}
        />
      )))
  }

  const getScoreColor = (score) => {
    if (score <= 30) return 'green';
    if (score <= 60) return 'orange';
    return 'red';
  };

  return (
    <React.Fragment>
      <Paper
        id={`scroll-to-id-${image.formQaImageId}`}
        className={classnames(classes.card, 'border-left-green')}
        elevation={1}
      >
        <Grid container spacing={0}>
          <Grid
            item
            md={7}
            xs={12}
            style={{
              paddingRight: 12,
              position: 'relative',
            }}
          >
            <div
              className={classes.imgWrapper}
              ref={divImgWrapper}
              style={{
                minHeight: maxImageHeight,
                ...imageContainerProps.style,
              }}
            >
              {!!imageProps.style?.height && (
                <img
                  className={classnames(classes.img, {
                    [classes.fraudulent]: image.fraudulent
                  })}
                  src={imageSrc}
                  alt={image.questionValue}
                  ref={imgWrapperRef}
                  style={imageProps.style}
                />
              )}

              {image.betterViewCaptureDate && (
                <div className={classes.betterViewCaptureDate}>
                  BetterView Capture Date: {format(new Date(image.betterViewCaptureDate), 'M/dd/yyyy')}
                </div>
              )}
            </div>
          </Grid>
          <Grid item md={5} xs={12}>
            <div className={classes.actionsWrapper}>
              <div className={classes.buttonWrapper}>
                <Button aria-label="Edit Issue(s)" className={classes.button} onClick={handleEditIssueDialogOpen}>
                  <EditIcon />
                </Button>
                <Button aria-label="Rotate Image" className={classes.button} onClick={rotateImage}>
                  <RotateRightIcon />
                </Button>
                <Button
                  aria-label="Toggle Image Display on Final Report"
                  className={classnames(classes.button, image.hideImage && classes.hideImage)}
                  onClick={toggleImageVisibilityOnReport}
                >
                  {image.hideImage ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </Button>
                <Button
                  aria-label="Toggle Image Fraudulence Indicator"
                  className={classnames(classes.button, image.fraudulent && classes.fraudulent)}
                  onClick={toggleImageFraudIndicator}
                >
                  {<ReportIcon />}
                </Button>
                <Button aria-label="Edit Location(s)" className={classes.button} onClick={handleEditLocationDialogOpen}>
                  <PlaceIcon />
                </Button>
              </div>
              <div className={classes.locationWrapper}>
                <div className="col-center-center">
                  <PlaceIcon />
                </div>
                <div className={classes.locationText}>
                  {selectedLocationFormDefinitions &&
                    selectedLocationFormDefinitions.map((fd, index) => (
                      <React.Fragment key={'wrapper-' + fd.orderFormHeaderId + '_' + fd.formDefinitionId}>
                        <DialogListItem
                          //
                          key={fd.orderFormHeaderId + '_' + fd.formDefinitionId}
                          pictureFormDefinition={fd}
                          selectedLocationFormDefinitions={selectedLocationFormDefinitions}
                          setSelectedLocationFormDefinitions={setSelectedLocationFormDefinitions}
                          state={state}
                          classes={classes}
                          condensed
                          onCheck={() => setShouldSaveLocations(true)}
                          locationsInModal={selectedLocationsInModal}
                          setLocationsInModal={setSelectedLocationsInModal}
                        />
                        {/* {index > 0 && ', '}
                        {fd.questionValue.replace('Take Photo: ', '')} */}
                      </React.Fragment>
                    ))}
                  {selectedLocationFormDefinitions && selectedLocationFormDefinitions.length === 0 && (
                    <div style={{ margin: '10px 0' }}>No Location Specified</div>
                  )}
                </div>
              </div>
              {(image?.confidenceScore !== null && image?.confidenceScore !== undefined) &&
               (image?.confidenceReason !== null && image?.confidenceReason !== undefined) && (
                <Paper className={classes.confidenceSection}>
                  <Typography variant="h6" classes={{ subtitle1: classes.subtitle1 }}>
                    AI Image Analysis
                  </Typography>
                  <Divider />
                  <Typography
                    variant="subtitle1"
                    classes={{ subtitle1: classes.subtitle1 }}
                    style={{ color: getScoreColor(image.confidenceScore) }}
                  >
                    Confidence Score: {image.confidenceScore}
                  </Typography>
                  <Typography variant="body2">
                    Reason: {image.confidenceReason}
                  </Typography>
                </Paper>
              )}
              <div className={classes.labelWrapper}>
                <Typography variant="subtitle1" classes={{ subtitle1: classes.subtitle1 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                    {imageLocation(image)}
                    {geoLocationIcon(image)}
                    {geoFenceIcon(image)}
                  </span>
                  {imageLabel}
                </Typography>
                <Typography variant="body1">{imageDescription}</Typography>
              </div>
              
              <div className={classes.formDefinitionWrapper}>
                {formDefinitions &&
                  // formDefinitions.map(fd => (
                  //   <FormDefinition
                  //     key={fd.formDefinitionId + '-' + fd.orderFormHeaderId}
                  //     saveAnswers={saveAnswers}
                  //     removeAnswers={removeAnswers}
                  //     formDefinition={fd}
                  //     showMinimalPhotoTaggedButton
                  //     // isReadOnly={true}
                  //     imageToEdit={image}
                  //     duplicateQuestion={formDefinitions.some(
                  //       fds => fds.questionId === fd.questionId && fds.formDefinitionId !== fd.formDefinitionId,
                  //     )}
                  //   />
                  // ))
                  filterFormDefs(formDefinitions, image)
                }
                {formDefinitions && formDefinitions.filter(fd => fd.answerType !== 'Picture').length === 0 && (
                  <div className={classes.noIssues}>No Issues Reported</div>
                )}
              </div>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Dialog
        //
        open={isEditLocationsDialogOpen}
        onClose={handleEditLocationDialogClose}
        disableBackdropClick={state.isAutoSaving}
        disableEscapeKeyDown={state.isAutoSaving}
      >
        <DialogTitle id="form-dialog-title">Edit Locations</DialogTitle>
        <DialogContent>
          <DialogContentText>Please select the location(s) you would like this image to appear:</DialogContentText>

          {locationFormDefinitionsByFormHeader.map(([formHeaderId, formDefs], index) => {
            const formHeader = state.formHeaders.find(fh => fh.formHeaderId == Number(formHeaderId));
            const grouped = formDefs.reduce((groups, item) => {
              const { orderFormHeaderId } = item;
              if (!groups[orderFormHeaderId]) {
                groups[orderFormHeaderId] = [];
              }
              groups[orderFormHeaderId].push(item);
              return groups;
            }, {});

            return (
              <Accordion key={formHeaderId}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <div className={classnames('row-start-center flex-1 text-left')}>
                    <Typography className={classnames(classes.heading, 'flex-1')}>{formHeader?.name}</Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails className="flex-column">
                  {Object.values(grouped).length === 1
                    ? formDefs.map(fd => (
                      <DialogListItem
                        //
                        key={fd.orderFormHeaderId + '_' + fd.formDefinitionId}
                        pictureFormDefinition={fd}
                        selectedLocationFormDefinitions={selectedLocationFormDefinitions}
                        setSelectedLocationFormDefinitions={setSelectedLocationFormDefinitions}
                        state={state}
                        classes={classes}
                        locationsInModal={selectedLocationsInModal}
                        setLocationsInModal={setSelectedLocationsInModal}
                      />
                    ))
                    : Object.values(grouped).map((group, index) => {
                      return (
                        <Accordion key={index}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className={classnames('row-start-center flex-1 text-left')}>
                              <Typography className={classnames(classes.heading, 'flex-1')}>
                                {formHeader?.name + ' #' + (index + 1)}
                              </Typography>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails className="flex-column">
                            {group.map(fd => (
                              <DialogListItem
                                //
                                key={fd.orderFormHeaderId + '_' + fd.formDefinitionId}
                                pictureFormDefinition={fd}
                                selectedLocationFormDefinitions={selectedLocationFormDefinitions}
                                setSelectedLocationFormDefinitions={setSelectedLocationFormDefinitions}
                                state={state}
                                classes={classes}
                                locationsInModal={selectedLocationsInModal}
                                setLocationsInModal={setSelectedLocationsInModal}
                              />
                            ))}
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </DialogContent>
        <DialogActions>
          {state.isAutoSaving && <CircularProgress size={15} className={classes.circularProgressBlue} />}

          <Button onClick={handleEditLocationDialogClose} color="primary" disabled={state.isAutoSaving}>
            Cancel
          </Button>
          <Button onClick={saveEditLocationChanges} color="primary" disabled={state.isAutoSaving}>
            {state.isAutoSaving ? 'Saving' : 'Save Changes'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={isEditIssueDialogOpen}
        onClose={handleEditIssueDialogClose}
        aria-labelledby="form-dialog-title"
      >
        <AppBar color="primary" className={classes.editIssueAppbar}>
          <Toolbar className={classes.editIssueToolbar}>
            <Typography variant="h6" color="inherit" className={classes.flex}>
              Edit Photo
            </Typography>
            <div className={classes.toolbarAutoSaveWrapper}>
              {state.isAutoSaving ? (
                <Typography variant="subtitle1" className={classes.toolbarAutoSave}>
                  {'Saving... '}
                  <CircularProgress size={15} className={classes.circularProgress} />
                </Typography>
              ) : (
                <Typography variant="subtitle2" className={classes.toolbarAutoSave}>
                  Saved <TimeAgo />
                </Typography>
              )}
              <IconButton color="inherit" onClick={handleEditIssueDialogClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Grid container spacing={0}>
            <Grid
              item
              md={9}
              xs={12}
              style={{
                position: 'sticky',
                top: 0,
                alignSelf: 'flex-start',
              }}
            >
              <ImageEditor image={image} />
            </Grid>
            <Grid item md={3} xs={12}>
              <div className={classes.issueFormDefinitions}>
                <div>
                  <Typography variant="subtitle1" classes={{ subtitle1: classes.subtitle1 }}>
                    Filter Questions
                  </Typography>
                  <div className={classnames('row-between-center', classes.questionFilterContainer)}>
                    <TextField
                      className={classes.questionFilterInput}
                      value={questionSearchText}
                      onChange={event => setQuestionSearchText(event.target.value.toLowerCase())}
                      margin="none"
                    />

                    <Button className={classes.questionFilterClearButton} onClick={() => setQuestionSearchText('')}>
                      <CloseIcon />
                    </Button>
                  </div>
                </div>

                <Typography variant="subtitle1" classes={{ subtitle1: classes.subtitle1 }}>
                  Label
                </Typography>
                <TextField
                  className={classes.textField}
                  value={imageLabel}
                  onChange={event => handlePropertyChange('Label', event)}
                  onBlur={handlePropertySave}
                  margin="none"
                  multiline
                />

                <Typography variant="subtitle1" classes={{ subtitle1: classes.subtitle1 }}>
                  Description
                </Typography>
                <TextField
                  className={classes.textField}
                  value={imageDescription}
                  onChange={event => handlePropertyChange('Description', event)}
                  onBlur={handlePropertySave}
                  margin="none"
                  multiline
                />

                <Typography variant="h5" classes={{ h5: classes.photoSpecificSubtitle1 }}>
                  Photo Specific
                </Typography>
                {photoSpecificFormDefs.map(fd => (
                  <>
                    <div key={fd.formDefinitionId}>
                      <Typography variant="subtitle1" classes={{ subtitle1: classes.subtitle1 }}>
                        {isQaOnlyAnswer(fd)}
                        {fd.questionValue}
                        {getImageAnswerCount(fd)}
                      </Typography>
                      <FormDefinition
                        saveAnswers={saveAnswers}
                        removeAnswers={removeAnswers}
                        formDefinition={fd}
                        imageToEdit={image}
                        isReadOnly={false}
                        showTitle={false}
                      />
                    </div>
                  </>
                ))}

                <Divider />

                <Typography variant="h5" classes={{ h5: classes.generalSubtitle1 }}>
                  General
                </Typography>
                {generalFormDefs.map(fd => (
                  <div key={fd.formDefinitionId}>
                    <FormDefinition
                      saveAnswers={saveAnswers}
                      removeAnswers={removeAnswers}
                      formDefinition={fd}
                      imageToEdit={image}
                      isReadOnly={false}
                      showMinimalPhotoTaggedButton
                      customTitle={
                        <Typography variant="subtitle1" classes={{ subtitle1: classes.subtitle1 }}>
                          {isQaOnlyAnswer(fd)}
                          {fd.questionValue}
                          {getImageAnswerCount(fd)}
                        </Typography>
                      }
                    />
                  </div>
                ))}
              </div>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

const styles = theme => ({
  img: {
    width: '100%',
    top: 12,
    borderRadius: 10,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(200, 100, 100, 0.3)',
      display: 'none',
    },
    '$fraudulent &::after': {
      display: 'block',
    },
  },
  imgWrapper: {
    position: 'sticky',
    top: 0,
  },
  hideImage: {
    backgroundColor: 'rgb(200, 100, 100)',
  },
    fraudulent: {
    backgroundColor: 'rgb(200, 100, 100)',
  },
  listItemIconCheck: {
    '& svg': {
      fontSize: 19,
      color: '#70bf49',
      fill: '#70bf49',
    },
  },
  tooltip: {
    fontSize: '0.8rem',
  },
  card: {
    // marginLeft: "12px",
    marginBottom: '12px',
    padding: '12px',
    width: '100%',
  },
  cardContent: {},
  button: {
    width: '100%',
    '&:hover': {
      cursor: 'pointer',
    },
    border: '1px solid #ebebeb',
  },
  buttonWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 6,
  },
  locationWrapper: {
    // width: '100%',
    display: 'flex',
    flexDirection: 'row',
    margin: '6px 0 6px 0',
    border: '1px solid #ebebeb',
    borderRadius: 4,
    paddingLeft: 10,
  },
  locationText: {
    marginLeft: '6px',
    width: '100%',
  },
  actionsWrapper: {
    padding: '0 0 0 12px',
    height: '100%',
  },
  formDefinitionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'flex-start',
  },
  noIssues: {
    textAlign: 'center',
    width: '100%',
    marginTop: '24px',
    color: 'rgba(0, 0, 0, 0.38)',
  },
  issueFormDefinitions: {
    padding: '0 0 0 24px',
    marginLeft: '24px',
  },
  subtitle1: {
    fontWeight: '700',
  },
  editIssueAppbar: {
    position: 'relative',
    marginBottom: '16px',
    background: '#315382',
  },
  editIssueToolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  photoSpecificSubtitle1: {
    fontWeight: '700',
    margin: '0 0 24px 0',
    textAlign: 'center',
  },
  generalSubtitle1: {
    fontWeight: '700',
    margin: '18px 0 18px 0',
    textAlign: 'center !important',
  },
  toolbarAutoSaveWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toolbarAutoSave: {
    color: '#fff',
  },
  circularProgress: {
    color: '#fff',
  },
  circularProgressBlue: {
    color: 'var(--jmi-blue)',
  },
  labelWrapper: {
    margin: '0 0 12px 6px',
  },
  textField: {
    marginBottom: '24px',
    width: '100%',
  },
  betterViewCaptureDate: {
    marginTop: 6,
  },

  questionFilterContainer: {
    marginBottom: 24,
  },
  questionFilterInput: {
    flex: 1,
    marginRight: 12,
  },
  questionFilterClearButton: {
    backgroundColor: 'var(--jmi-blue)',
    color: '#fff',
    '&:hover': {
      background: 'var(--jmi-blue-hover)',
    },
  },
  confidenceSection: {
    marginTop: 12,
    marginBottom: 12,
    padding: 12,
    border: '1px solid #ebebeb',
    borderRadius: 4,
  },
});

ImageCard.propTypes = propTypes;

export default withStyles(styles)(ImageCard);
